import type { Client } from './client';

/** Append the app hint to a URL meant for a browser NAVIGATION.
 *
 * Fetches identify their app with the X-Client-App header; an <a href>,
 * window.open or an EventSource cannot set headers. The server accepts an
 * `app` query param for exactly those cases. Without it, it falls back to
 * trying each session cookie in turn — so a browser signed into two apps
 * authenticates as whichever is tried first, which is neither predictable nor
 * what the user is looking at.
 */
export function withApp(client: Client, path: string): string {
  if (!client.app) return path;
  return `${path}${path.includes('?') ? '&' : '?'}app=${encodeURIComponent(client.app)}`;
}
